import { FormErrorMessage, FormErrorMessageProps } from "@chakra-ui/react";
import { FieldError, FieldErrorsImpl, Merge } from "react-hook-form";

interface ErrorTextProps extends FormErrorMessageProps {
  error: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
  reserveErrorSpace?: boolean;
}

export default function ErrorText({ error, reserveErrorSpace = true, ...rest }: ErrorTextProps) {
  return error ? (
    <FormErrorMessage mt="1" fontSize="xs" color="error.DEFAULT" {...rest}>
      {(error as any).message}
    </FormErrorMessage>
  ) : reserveErrorSpace ? (
    <FormErrorMessage mt="1" fontSize="xs" color="error.DEFAULT" {...rest}>
      &nbsp;
    </FormErrorMessage>
  ) : (
    null
  );
}
